export default __webpack_public_path__ + "static/media/step3_shake.8c7cf66c.png";